'use client';

import ShopDetailIntroduce from '@/components/shop/shop-detail-introduce';
import ShopDetailMessages from '@/components/shop/shop-detail-messages';
import ShopDetailPromotion from '@/components/shop/shop-detail-promotion';
import useLogEvents from '@/lib/client-hook/use-log-events';
import { convertLanguageName } from '@/lib/convert-language-code';
import { Languages } from '@/lib/dictionaries';
import { store } from '@/lib/store';
import { IShop } from '@/schema/shop';
import React, { useState } from 'react';
import { Provider } from 'react-redux';

import classes from './shop-detail-home.module.scss';

enum ShopDetailTabName {
  Intro = 'DETAIL',
  Promotion = 'EVENT',
  Cheer = 'LIVE CHAT',
}

function ShopDetailTab({ lang, shop }: { lang: Languages; shop: IShop }) {
  const [tabName, setTabName] = useState(ShopDetailTabName.Intro);

  const { logShareEvent } = useLogEvents();

  const handleChangeTab = (newTabName: ShopDetailTabName) => {
    logShareEvent('bnb_shop_detail_tab', {
      state: newTabName,
    });
    setTabName(newTabName);
  };

  return (
    <>
      <div className={classes.detailTabsList}>
        <article className={`${classes.tabsListLayout1} ${classes.th}`}>
          <div className={classes.tabsList}>
            <ul>
              <li>
                <button
                  className={`${classes.tabsBtn} ${tabName === ShopDetailTabName.Intro && classes.active}`}
                  onClick={() => handleChangeTab(ShopDetailTabName.Intro)}
                >
                  DETAIL
                </button>
              </li>
              {shop.missions.length > 0 && (
                <li>
                  <button
                    className={`${classes.tabsBtn} ${tabName === ShopDetailTabName.Promotion && classes.active}`}
                    onClick={() => handleChangeTab(ShopDetailTabName.Promotion)}
                  >
                    GIFTIFAN EVENT
                  </button>
                </li>
              )}
              <li>
                <button
                  className={`${classes.tabsBtn} ${tabName === ShopDetailTabName.Cheer && classes.active}`}
                  onClick={() => handleChangeTab(ShopDetailTabName.Cheer)}
                >
                  LIVE CHAT
                </button>
              </li>
            </ul>
          </div>
        </article>
      </div>
      <div className={classes.detailTabsGroup}>
        <div className={classes.tabsBox}>
          {tabName === ShopDetailTabName.Intro && (
            <ShopDetailIntroduce
              lang={lang}
              title={shop.title[lang]}
              images={shop.images[lang]}
              usageChartImage={shop.usageChartImage}
              commonImages={shop.commonImages}
              productNoticeImages={shop.productNoticeImages}
            />
          )}
          {tabName === ShopDetailTabName.Promotion && (
            <ShopDetailPromotion missionImages={shop.missionImages} />
          )}
          {tabName === ShopDetailTabName.Cheer && (
            <Provider store={store}>
              <ShopDetailMessages shopId={shop.id} />
            </Provider>
          )}
        </div>
      </div>
    </>
  );
}

export default ShopDetailTab;
